/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { PanelsContext } from "../Context/PanelsContext";
import { useOutsideAlerter } from "../components/GlobalComponents/HandleClick";
import UploadImg from "./UploadImg";
import Wrapper from "../components/GlobalComponents/Wrapper";
import Row from "../components/GlobalComponents/Row";
import Title from "../components/GlobalComponents/Title";
import SubTitle from "../components/GlobalComponents/SubTitle";
import Slider from "../components/GlobalComponents/Slider";
import IconModal from "./IconModal";
import Icon1 from "../img/icon1.png";

const GeneralSettings = () => {
  const {
    text,
    setText,
    setFontFamily,
    fontWeight,
    setFontWeight,
    fontSize,
    setFontSize,
    openIconPicker,
    setOpenIconPicker,
    imgSize,
    setImgSize,
    removeImg,
    handleShowImg,
    clickRef,
  } = useContext(PanelsContext);

  useOutsideAlerter(clickRef, () => setOpenIconPicker(true));

  return (
    <div css={styles} className="generalSettings">
      <Row>
        <Title title="Text" />
      </Row>
      <Row>
        <SubTitle text="Text Content" />
        <Slider inputType="text" val={text} setVal={setText} />
      </Row>
      <Row>
        <SubTitle text="Font Family" />
        <select onChange={(e) => setFontFamily(e.target.value)}>
          <option value="Montserrat">Montserrat</option>
          <option value="Raleway">Raleway</option>
          <option value="Poppins">Poppins</option>
          <option value="Barlow">Barlow</option>
          <option value="Libre Franklin">Libre Franklin</option>
          <option value="Kanit">Kanit</option>
          <option value="Grenze">Grenze</option>
        </select>
      </Row>
      <Row>
        <SubTitle text="Font Weight" />
        <Wrapper>
          <Slider
            inputType="range"
            minVal="100"
            maxVal="900"
            stepVal="100"
            defVal={fontWeight}
            setVal={setFontWeight}
          />
          <p>{fontWeight}</p>
        </Wrapper>
      </Row>
      <Row>
        <SubTitle text="Font Size" />
        <Wrapper>
          <Slider
            inputType="range"
            minVal="14"
            maxVal="44"
            defVal={fontSize}
            setVal={setFontSize}
          />
          <p>{fontSize}px</p>
        </Wrapper>
      </Row>
      <Row>
        <Title title="Icon" />
      </Row>
      <Row>
        <SubTitle text="Disable Icon" />
        <label className="switch">
          <input onChange={handleShowImg} type="checkbox" checked={removeImg} />
          <span className="slider round"></span>
        </label>
      </Row>
      <Row>
        <SubTitle text="Icon Scale" />
        <Wrapper>
          <Slider
            inputType="range"
            minVal="20"
            maxVal="60"
            defVal={imgSize}
            setVal={setImgSize}
          />
          <p>{imgSize}px</p>
        </Wrapper>
      </Row>
      <Row>
        <SubTitle text="Select an Icon" />
        <div ref={clickRef}>
          <IconModal />
          <button onClick={() => setOpenIconPicker(!openIconPicker)}>
            <img src={Icon1} alt="icon" />
            Open Icon Picker
          </button>
        </div>
      </Row>
      <Row>
        <SubTitle text="Upload Custom Icon" />
        <UploadImg />
      </Row>
    </div>
  );
};

const styles = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .row {
    &:nth-child(9) {
      position: relative;
    }
    &:nth-child(1),
    &:nth-child(6) {
      max-width: 100%;
    }
    input,
    select {
      width: 100%;
      padding: 14px;
      background: #181b21;
      border: none;
      outline: none;
      color: #fff;
      &::placeholder {
        color: #fff;
      }
    }
    button {
      border: none;
      outline: none;
      padding: 14px;
      background: #e6004e;
      color: #fff;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: background 700ms ease-in-out;
      &:hover {
        background: #a90d42;
      }
      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
        display: block;
      }
    }
    .wrapper {
      input {
        width: 70%;
        padding: 0;
      }
      p {
        color: #fff;
        font-size: 15px;
      }
    }
    .switch {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 34px;
      input {
        opacity: 0;
        width: 0;
        height: 0;
        &:checked + .slider:before {
          -webkit-transform: translateX(26px);
          -ms-transform: translateX(26px);
          transform: translateX(26px);
        }
        &:checked + .slider {
          background-color: #181b21;
        }
        &:focus + .slider {
          box-shadow: 0 0 1px #181b21;
        }
      }
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #181b21;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        &.round {
          border-radius: 34px;
          &:before {
            border-radius: 50%;
          }
        }
        &:before {
          position: absolute;
          content: "";
          height: 26px;
          width: 26px;
          left: 4px;
          bottom: 4px;
          background-color: #a90d42;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }
      }
    }
  }
  @media (max-width: 650px) {
    .row {
      &:nth-child(9), &:last-of-type{
        .subtitle{
          font-size: 14px;
        }
        button{
          font-size: 10px;
          height: 50px;
        }
      }
    }
  }
`;

export default GeneralSettings;
